export default __webpack_public_path__ + "static/media/shield.a0be1a50.svg";